<template>
  <div v-if="isReady" class="content">
    <template v-for="(group, group_id) in fieldGroups">
      <field-group
        :group-id="group_id"
        group-type="fieldset"
        :group-label="group.label"
        :group-config="group"
        :key="group_id"
      >
        <template v-for="childElement in getChildFields(group.children)">
          <!-- It'd be super cool if we could refactor this out into some generic reusable Field component! -->
          <div
            class="field"
            v-if="isNotEmpty(fieldData[childElement.name])"
            :key="childElement.name"
          >
            <div class="field-label field__label">
              {{ displayFields2[childElement.name].label }}
            </div>
            <div
              v-if="vHtmlIsSet(displayFields2[childElement.name], fieldData)"
              v-html="
                displayFields2[childElement.name].formatter(
                  fieldData[childElement.name],
                ).v_html
              "
              class="field-item field__item"
            />
            <div
              v-else-if="displayFields2[childElement.name].type === 'link'"
              class="field-item field__item"
            >
              <b-link
                v-if="fieldData[childElement.name].url"
                :href="fieldData[childElement.name].url"
              >
                {{
                  displayFields2[childElement.name].formatter(
                    fieldData[childElement.name].text,
                  )
                }}
              </b-link>
              <span v-else>{{
                displayFields2[childElement.name].formatter(
                  fieldData[childElement.name].text,
                )
              }}</span>
            </div>
            <div
              v-else-if="
                displayFields2[childElement.name].type === 'file_listing'
              "
            >
              <file-attachment-listing
                :key="childElement.name + '-file-listing'"
                :files="fieldData[childElement.name]"
                allow-file-download
                allow-file-remove
              />
            </div>
            <div v-else class="field-item field__item">
              {{
                displayFields2[childElement.name].formatter(
                  fieldData[childElement.name],
                )
              }}
            </div>
          </div>
          <div
            v-else-if="childElement.name === 'field_inc_invest_recommendations'"
            :key="childElement.name"
          >
            <corrective-actions-listing
              key="field_inc_invest_recommendations"
              :investigation-uuid="uuid"
              :disabled="false"
            />
          </div>
        </template>
      </field-group>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import CorrectiveActionsListing from "./CorrectiveActionsListing.vue";
import EntityViewDisplayFieldFormatter from "../../lib/entity_view_display_field_formatters";
import FieldGroup from "../raft/FieldGroup.vue";
import FileAttachmentListing from "../FileAttachmentListing.vue";
import raftGenericHelper from "../../lib/raft_generic_helper";
import { restClient, jsonClient } from "../../lib/raftApi";

export default {
  name: "IncidentInvestigationView",
  components: {
    CorrectiveActionsListing,
    FieldGroup,
    FileAttachmentListing,
  },
  props: {
    uuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      defaultQueries: {
        include:
          "field_inc_invest_documents,field_inc_invest_group,field_inc_invest_department_unit,field_inc_invest_person_involved,field_inc_invest_root_causes,field_inc_invst_team_assigned,field_incident_report",
      },
      response: null,
      displayData: null,
      fieldData: null,
      fields: null,
      bundleFieldsSorted: [],
      displayFields2: null,
      perms: [],
      labelMap: {},
      typeMap: {
        field_inc_invest_documents: "file_listing",
        field_inc_invest_person_involved: "link",
      },
      fieldGroups: {
        group_report_processing: {
          children: [
            "field_incident_report",
            "field_inc_invst_team_assigned",
            "field_inc_invest_report_status",
          ],
          parent_name: "",
          weight: 0,
          format_type: "fieldset",
          region: "content",
          format_settings: {
            show_empty_fields: false,
            id: "",
            classes: "",
            description: "",
          },
          label: "Report Processing",
        },
        group_file_attachments: {
          children: ["field_inc_invest_documents"],
          parent_name: "",
          weight: 1,
          format_type: "fieldset",
          region: "content",
          format_settings: {
            show_empty_fields: false,
            id: "",
            classes: "",
            description: "",
          },
          label: "File Attachments",
        },
        group_initial_details: {
          children: [
            "field_inc_invest_gen_category",
            "field_inc_invest_rep_category",
            "field_inc_invest_area_type",
            "field_inc_invest_person_involved",
            "field_inc_invest_group",
            "field_inc_invest_department_unit",
            "field_inc_invest_job_title",
            "field_inc_invest_job_function",
            "field_inc_invest_job_func_other",
            "field_inc_invest_initial_details",
          ],
          parent_name: "",
          weight: 2,
          format_type: "fieldset",
          region: "content",
          format_settings: {
            show_empty_fields: false,
            id: "",
            classes: "",
            description: "",
          },
          label: "Initial Details",
        },
        group_investigation: {
          children: [
            "field_inc_invest_response_detail",
            "field_inc_invest_safety_controls",
            "field_inc_invest_witness_notes",
            "field_inc_invest_notes",
          ],
          parent_name: "",
          weight: 3,
          format_type: "fieldset",
          region: "content",
          format_settings: {
            show_empty_fields: false,
            id: "",
            classes: "",
            description: "",
          },
          label: "Investigation",
        },
        group_injury_or_illness_informat: {
          children: [
            "field_inc_invest_inj_person_name",
            "field_inc_invest_inj_job_title",
            "field_inc_invest_inj_physician",
            "field_inc_invest_inj_describe",
            "field_inc_invest_inj_days_away",
            "field_inc_invest_inj_xfer_days",
            "field_inc_invest_inj_inj_illness",
            "field_inc_invest_inj_ill_type",
            "field_inc_invest_inj_date_hired",
            "field_inc_invest_inj_trtmnt_loc",
            "field_inc_invest_inj_outcome",
            "field_inc_invest_inj_emerg_treat",
            "field_inc_invest_inj_hospital",
          ],
          parent_name: "",
          weight: 4,
          format_type: "fieldset",
          region: "content",
          format_settings: {
            show_empty_fields: false,
            id: "",
            classes: "grid",
            description: "",
          },
          label: "Injury or Illness Information",
        },
        group_b: {
          children: ["field_bls_codes"],
          parent_name: "",
          weight: 5,
          format_type: "fieldset",
          region: "content",
          format_settings: {
            show_empty_fields: false,
            id: "",
            classes: "",
            description: "",
          },
          label: "BLS Codes",
        },
        group_root_cause: {
          children: [
            "field_inc_invest_root_causes",
            "field_inc_invest_root_cause_desc",
          ],
          parent_name: "",
          weight: 6,
          format_type: "fieldset",
          region: "content",
          format_settings: {
            show_empty_fields: false,
            id: "",
            classes: "",
            description: "",
          },
          label: "Root Cause",
        },
        group_corrective_preventative_ac: {
          children: ["field_inc_invest_recommendations"],
          parent_name: "",
          weight: 7,
          format_type: "fieldset",
          region: "content",
          format_settings: {
            show_empty_fields: false,
            id: "",
            classes: "",
            description: "",
          },
          label: "Corrective/Preventative Actions",
        },
        group_summary: {
          children: ["field_inc_invest_summary"],
          parent_name: "",
          weight: 8,
          format_type: "fieldset",
          region: "content",
          format_settings: {
            show_empty_fields: false,
            id: "",
            classes: "",
            description: "",
          },
          label: "Summary",
        },
      },
    };
  },
  computed: {
    ...mapState("incidentManagementStore", ["blsCodes"]),
    isReady: function () {
      return (
        this.isNotEmpty(this.displayData) && this.isNotEmpty(this.response)
      );
    },
  },
  async created() {
    this.fetchInvestigationDisplay();
    this.fetchInvestigation();
    await this.fetchBlsCodes();
  },
  methods: {
    ...mapActions("incidentManagementStore", ["fetchBlsCodes"]),
    async fetchInvestigation() {
      const options = {
        path: "node/incident_investigation/" + this.uuid,
        queries: this.defaultQueries,
      };
      const response = await jsonClient.get(options).catch(this.errorEmit);
      this.buildFieldData(response);
      this.response = response;
    },
    async fetchInvestigationDisplay() {
      const options = {
        path: "entity-view-display/node/incident_investigation",
        queries: {
          display_id: "default",
        },
      };
      const response = await restClient.get(options).catch(this.errorEmit);
      const data = response.incident_investigation;
      this.displayData = data.default;
      this.setDisplayFields();
    },
    isNotEmpty: function (obj) {
      // Handles object and array.
      if (obj && typeof obj === "object") {
        return Object.keys(obj).length > 0;
      }
      if (typeof obj === "boolean" || typeof obj === "number") {
        return true;
      }
      return !!obj;
    },
    setDisplayFields() {
      this.displayFields2 = {};

      Object.entries(this.displayData).forEach((display) => {
        const [fieldName, data] = display;
        const field = { name: fieldName, label: data.label };
        // Map types.
        data.display_settings.type =
          this.typeMap[fieldName] || data.display_settings.type;
        // Map labels.
        field.label = this.labelMap[fieldName] || field.label;
        if (!field.label.endsWith("?") && !field.label.endsWith(":")) {
          field.label += ":";
        }
        // Add types to fields to more easily use conditionals in the templates.
        field.type = data.display_settings.type;
        if (fieldName === "field_bls_codes") {
          field.formatter = (value) => this.formatBlsCodeField(value);
        } else {
          field.formatter = (value) =>
            EntityViewDisplayFieldFormatter.fieldFormatter(value, data);
        }
        this.displayFields2[field.name] = field;
      });
    },
    getChildFields: function (fieldGroupChildren) {
      const children = [];
      if (Array.isArray(fieldGroupChildren)) {
        fieldGroupChildren.forEach((fieldName) => {
          const field = this.displayFields2[fieldName];
          if (field) {
            children.push(field);
          }
        });
      }
      return children;
    },
    buildFieldData: function (response) {
      this.fieldData = {};
      Object.entries(response.data.attributes).forEach((field) => {
        const [name, value] = field;
        this.fieldData[name] = value;
      });
      // Handle title.
      raftGenericHelper.setPageTitle(this.fieldData.title);
      delete this.fieldData.title;
      // Handle relations.
      const flattened = response.deserialized;
      const relationships = [
        "field_inc_invest_department_unit",
        "field_inc_invest_documents",
        "field_inc_invest_group",
        "field_inc_invest_person_involved",
        "field_inc_invest_root_causes",
        "field_inc_invst_team_assigned",
        "field_incident_report",
      ];
      relationships.forEach((key) => {
        if (flattened.hasOwnProperty(key)) {
          // @todo Unify with code in EntityViewDisplayFieldFormatters.formatEntityReferenceLabel().
          let entities = [];
          const output = [];
          if (Array.isArray(flattened[key])) {
            entities = flattened[key];
          } else if (flattened[key]) {
            entities.push(flattened[key]);
          }
          const fields = [
            "field_prof_display_name",
            "display_name",
            "name",
            "title",
            "label",
          ];
          entities.forEach((entity) => {
            for (const field_name of fields) {
              if (entity.hasOwnProperty(field_name)) {
                output.push(entity[field_name]);
                break;
              }
            }
          });
          this.fieldData[key] = output.join(", ");
        }
      });

      // Fix created date format.
      const createdDate = new Date(this.fieldData.created);
      this.fieldData.created =
        raftGenericHelper.formatDateFilterYyyyMmDd(createdDate);

      // Handle file uploads.
      this.fieldData.field_inc_invest_documents =
        flattened.field_inc_invest_documents;

      // Person involved.
      if (flattened.field_inc_invest_person_involved) {
        this.fieldData.field_inc_invest_person_involved = {
          text: flattened.field_inc_invest_person_involved
            .field_prof_display_name
            ? flattened.field_inc_invest_person_involved.field_prof_display_name
            : flattened.field_inc_invest_person_involved.display_name,
          url:
            "/user/" +
            flattened.field_inc_invest_person_involved.drupal_internal__uid,
        };
      }
    },
    formatBlsCodeField(values) {
      const output = { v_html: "" };
      Object.entries(values).forEach(([key, value]) => {
        if (value) {
          const match = this.blsCodes.find((c) => parseInt(c.id, 10) === value);
          if (match) {
            output.v_html +=
              "<li>" + match.code + " - " + match.title + "</li>";
          }
        }
      });
      if (output.v_html) {
        output.v_html = '<ul class="bls-codes-list">' + output.v_html + "</ul>";
        return output;
      }
      return "";
    },
    errorEmit(message, data) {
      this.$emit("form-error-message", { message: message, data: data });
    },
    vHtmlIsSet(displayField, fieldData) {
      return !!(
        displayField.formatter(fieldData[displayField.name]) &&
        displayField
          .formatter(fieldData[displayField.name])
          .hasOwnProperty("v_html") &&
        typeof displayField.formatter(fieldData[displayField.name]).v_html !==
          "undefined"
      );
    },
  },
};
</script>

<style scoped>
div.field {
  display: block;
  overflow: auto;
  clear: both;
  margin: 0.5em 0;
}

.field-label.field__label {
  width: 200px;
  float: left;
  display: inline-block;
  vertical-align: top;
}

.field-item.field__item {
  display: table-cell;
  vertical-align: top;
}

:deep(ul.bls-codes-list) {
  padding-left: 1em;
}
</style>
